<template>
  <div class="index">
      {{message}}
      <div>asdfasdfasdfasdfasdf
      </div>
</div>
</template>

<script type="text/javascript">
export default { // 这里需要将模块引出，可在其他地方使用
  name: 'Main',
  data() { // 注意：data即使不需要传数据，也必须return,否则会报错
    return {
      message: '啦啦啦啦啦'
    }
  }
}
</script>
